import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';

const fetchDefault = () => (dispatch) => {
    ApiService.get(Path.PRODUCTCLASS_GET_LIST)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
        }).catch(()=>{
            dispatch(Actions.setList([])); 
        })
};

const viewProductClass = (payload) => () => {
    return ApiService.view(Path.PRODUCTCLASS_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const addProductClass = (payload) => () => {
    return ApiService.add(Path.PRODUCTCLASS_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const editProductClass = (payload) => () => {
    return ApiService.update(Path.PRODUCTCLASS_GET_LIST, payload)
        .then((response) => {
            return response.data;
        })
};

const deleteProductClass = (id) => () => {
    return ApiService.delete(Path.PRODUCTCLASS_GET_LIST, id)
        .then((response) => {
            return response.data;
        })
};

export {
    fetchDefault,
    addProductClass,
    editProductClass,
    deleteProductClass,
    viewProductClass
};
